module.exports = __webpack_public_path__ + "img/pdf.b9639b70.jpg";